import { render, staticRenderFns } from "./TobaccoButton.vue?vue&type=template&id=5fb850d0"
import script from "./TobaccoButton.vue?vue&type=script&lang=js"
export * from "./TobaccoButton.vue?vue&type=script&lang=js"
import style0 from "./TobaccoButton.vue?vue&type=style&index=0&id=5fb850d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports